export enum TableSortingMode {
  DEFAULT = 'default',
  DRAG_AND_DROP = 'drag-and-drop',
}
